import { useState } from 'react'
import Icon from 'core/components/icons/Icon'
import { useSettings } from 'core/hooks/useSettings'
import useNavigation from 'core/hooks/useNavigation'
import useTailwindBreakpoint from 'core/hooks/useTailwindBreakpoint'
import useUrlIsAppRequest from 'core/hooks/useUrlIsAppRequest'

const MobileWarning = () => {
  const { isMobile } = useTailwindBreakpoint()

  const {
    data: { inAppView }
  } = useSettings()
  const { pathname } = useNavigation()
  const isAppRequest = useUrlIsAppRequest()
  const complianceUrlRegex = new RegExp(/(compliance)/g)
  const reportUrlRegex = new RegExp(/(report)/g)
  const teamsUrlRegex = new RegExp(/(teams)/g)
  const splashMessagePage = new RegExp(/(splash_message)/g)

  const isInReportPage = reportUrlRegex.test(pathname)
  const isInTeamsUrl = teamsUrlRegex.test(pathname)
  const isInCompliancePage = complianceUrlRegex.test(pathname)
  const isInSplashMessagePage = splashMessagePage.test(pathname)
  const [show, setShow] = useState(true)

  if (
    isAppRequest ||
    isInReportPage ||
    isInCompliancePage ||
    inAppView ||
    isInSplashMessagePage
  ) {
    return null
  }
  const defaultLabel = (
    <p>
      Our web dashboard is best viewed from a desktop browser. <br />{' '}
      <b>
        For the best mobile experience,{' '}
        <a
          className="underline text-md"
          href="https://link.everlance.com/gRuhKOVDAY"
        >
          open the Everlance app.
        </a>
      </b>
    </p>
  )
  const teamsLabel = (
    <p>Open the Team Dashboard on a desktop computer for the best experience</p>
  )
  return isMobile && show ? (
    <div className="flex bg-warning-1 justify-between p-5">
      {isInTeamsUrl ? teamsLabel : defaultLabel}
      <Icon
        name="close"
        color="text-dark-4"
        size={15}
        onClick={() => setShow(false)}
      />
    </div>
  ) : null
}

export default MobileWarning
